// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4f46357","453":"a3cdc674","455":"4607584d","977":"2565df9e"}[chunkId] + ".chunk.js";
};